// Infinite Scroll with IntersectionObserver, URL state, scroll restoration, and loader

document.addEventListener("DOMContentLoaded", () => {
  function getGrid() {
    return document.querySelector(".product-grid");
  }

  let loadNext = document.getElementById("loadNext");
  let loadPrevious = document.getElementById("loadPrevious");
  let loader = document.getElementById("loader");

  let loadingNext = false;
  let loadingPrevious = false;
  let currentPage = getPageFromURL() || 1;
  const loadedPages = new Set([currentPage]);
  let restoringScroll = false;

  const scrollObserver = new IntersectionObserver(handleIntersect, {
    rootMargin: "100px 0px",
    threshold: 0,
  });

  const pageObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const pageNum = parseInt(entry.target.dataset.pageNumber);
          if (!isNaN(pageNum)) {
            updateHistoryState(pageNum);
          }
        }
      }
    },
    {
      root: null,
      rootMargin: "0px 0px -80% 0px",
      threshold: 0,
    }
  );

  reconnectSentinels();
  observeAllPages(); // Observe already-visible page 1 on first load

  waitForFacetUpdated(() => {
    reconnectSentinels();
    observeAllPages(); // observe existing visible pages
    if (currentPage > 1) {
      restoreAndLoadUpToPage(currentPage);
    }
  });

  function handleIntersect(entries) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        if (entry.target.id === "loadNext") {
          loadPage("next");
        } else if (entry.target.id === "loadPrevious") {
          loadPage("previous");
        }
      }
    }
  }

  function loadPage(direction) {
    if (direction === "next" && loadingNext) return;
    if (direction === "previous" && loadingPrevious) return;

    const pdtGrid = getGrid();
    const trigger = direction === "next" ? loadNext : loadPrevious;
    if (!trigger) return;

    const url = trigger.getAttribute(`data-${direction}-url`);
    if (!url || loadedPages.has(getPageNumberFromURL(url))) return;

    if (direction === "next") loadingNext = true;
    if (direction === "previous") loadingPrevious = true;

    loader = document.getElementById("loader");
    if (loader) loader.classList.remove("hidden");

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const items = doc.querySelectorAll(".product-grid > li");
        const newPage = getPageNumberFromURL(url);
        loadedPages.add(newPage);

        if (direction === "next") {
          items.forEach((item) => {
            if (!item.id.includes("load")) {
              pdtGrid.appendChild(item);
              if (item.dataset.pageNumber) {
                pageObserver.observe(item);
              }
            }
          });
          updateHistoryState(newPage);
        } else {
          const firstVisible = pdtGrid.querySelector("li.grid__item");
          const scrollY = window.scrollY;
          const offsetBefore = firstVisible?.getBoundingClientRect().top ?? 0;

          const reversed = Array.from(items).reverse();
          reversed.forEach((item) => {
            if (!item.id.includes("load")) {
              pdtGrid.insertBefore(item, loadPrevious?.nextSibling);
              if (item.dataset.pageNumber) {
                pageObserver.observe(item);
              }
            }
          });

          requestAnimationFrame(() => {
            const offsetAfter = firstVisible?.getBoundingClientRect().top ?? 0;
            const diff = offsetAfter - offsetBefore;
            window.scrollTo({ top: scrollY + diff });
          });
        }

        const newNext = doc.getElementById("loadNext");
        const newPrev = doc.getElementById("loadPrevious");

        loadNext = document.getElementById("loadNext");
        loadPrevious = document.getElementById("loadPrevious");

        if (direction === "next") {
          if (loadNext && newNext?.dataset?.nextUrl) {
            loadNext.setAttribute("data-next-url", newNext.dataset.nextUrl);
          }
          // Do NOT touch loadPrevious here.
        }        
        if (direction === "previous") {
          if (loadPrevious && newPrev?.dataset?.previousUrl) {
            loadPrevious.setAttribute(
              "data-previous-url",
              newPrev.dataset.previousUrl
            );
          }
        }

        reconnectSentinels();
      })
      .catch((err) => console.error(`Error loading ${direction} page`, err))
      .finally(() => {
        if (loader) loader.classList.add("hidden");
        if (direction === "next") loadingNext = false;
        if (direction === "previous") loadingPrevious = false;
      });
  }

  function reconnectSentinels() {
    scrollObserver.disconnect();

    loadNext = document.getElementById("loadNext");
    loadPrevious = document.getElementById("loadPrevious");

    if (loadNext) {
      scrollObserver.observe(loadNext);
    }

    if (loadPrevious && !loadedPages.has(1)) {
      scrollObserver.observe(loadPrevious);
    }
  }

  function observeAllPages() {
    const grid = getGrid();
    const pageItems = grid.querySelectorAll("li[data-page-number]");
    pageItems.forEach((item) => pageObserver.observe(item));
  }

  function updateHistoryState(pageNum) {
    if (restoringScroll || currentPage === pageNum) return;

    const url = new URL(window.location.href);
    if (pageNum <= 1) {
      url.searchParams.delete("page");
    } else {
      url.searchParams.set("page", pageNum);
    }

    history.replaceState(null, "", url.toString());
    currentPage = pageNum;
  }

  function restoreAndLoadUpToPage(targetPage) {
    restoringScroll = true;
    const interval = setInterval(() => {
      const grid = getGrid();
      const pageEl = grid.querySelector(`li[data-page-number="${targetPage}"]`);
      if (pageEl) {
        pageEl.scrollIntoView({ behavior: "instant" });
        clearInterval(interval);
        restoringScroll = false;
      } else {
        loadPage("previous");
      }
    }, 300);
  }

  function waitForFacetUpdated(callback) {
    const handler = () => {
      callback();
      waitForFacetUpdated(callback);
    };
    document.addEventListener("facet:updated", handler, { once: true });
  }

  function getPageFromURL() {
    const params = new URLSearchParams(window.location.search);
    return parseInt(params.get("page")) || 1;
  }

  function getPageNumberFromURL(url) {
    try {
      const parsed = new URL(url, window.location.origin);
      return parseInt(parsed.searchParams.get("page")) || 1;
    } catch {
      return 1;
    }
  }
});
